import { Component, inject, resource } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TAGEvent } from '../../../models/tagevent';
import { ApiService } from '../../api.service';
import { SkeletonModule } from 'primeng/skeleton';
import { EventListitemComponent } from '../../components/event-listitem/event-listitem.component';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '../../components/mat-icon/mat-icon';

@Component({
  selector: 'app-home',
  imports: [ButtonModule, SkeletonModule, EventListitemComponent, TranslatePipe, MatIcon, RouterLink],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class Home {
  private api = inject(ApiService);
  private router = inject(Router);

  events = resource({
    defaultValue: [] as TAGEvent[],
    loader: ({}) => {
      return new Promise<TAGEvent[]>((resolve, reject) => {
        this.api.waitForAPI().then(() => {
          this.api
            .getEvents(true)
            .then((events: TAGEvent[]) => {
              //resolve([]);
              events.sort((a, b) => a.startdate.getTime() - b.startdate.getTime());
              resolve(events.filter((e) => e.enddate > new Date()));
            })
            .catch((reason) => {
              reject(reason);
            });
        });
      });
    }
  });

  images = resource({
    defaultValue: [] as TAGEvent[],
    loader: ({}) => {
      return new Promise<TAGEvent[]>((resolve, reject) => {
        this.api.waitForAPI().then(() => {
          reject('No Images');
        });
      });
    },
  });

  openEventDetails(eventid: string) {
    this.router.navigate(['/events'], { queryParams: { eventid: eventid } });
  }
}
